/* eslint-disable max-lines */
/* eslint-disable import/max-dependencies */
import { isDefined } from "@clipboard-health/util-ts";
import { SvgIcon, type SvgIconProps } from "@mui/material";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics";
import ArrowDown from "@src/appV2/lib/assets/icons/arrow_down.svg?react";
import ArrowLeft from "@src/appV2/lib/assets/icons/arrow_left.svg?react";
import ArrowRight from "@src/appV2/lib/assets/icons/arrow_right.svg?react";
import ArrowUp from "@src/appV2/lib/assets/icons/arrow_up.svg?react";
import BlockShift from "@src/appV2/lib/assets/icons/block_shift.svg?react";
import BoltFilled from "@src/appV2/lib/assets/icons/bolt_filled.svg?react";
import BookmarkFilled from "@src/appV2/lib/assets/icons/bookmark_filled.svg?react";
import BookmarkOutlined from "@src/appV2/lib/assets/icons/bookmark_outlined.svg?react";
import Break from "@src/appV2/lib/assets/icons/break.svg?react";
import Building from "@src/appV2/lib/assets/icons/building.svg?react";
import CalendarClock from "@src/appV2/lib/assets/icons/calendar_clock.svg?react";
import CalendarNavigation from "@src/appV2/lib/assets/icons/calendar_navigation.svg?react";
import CalendarRemove from "@src/appV2/lib/assets/icons/calendar_remove.svg?react";
import Car from "@src/appV2/lib/assets/icons/car.svg?react";
import Chat from "@src/appV2/lib/assets/icons/chat.svg?react";
import Checkmark from "@src/appV2/lib/assets/icons/checkmark.svg?react";
import ChevronDown from "@src/appV2/lib/assets/icons/chevron_down.svg?react";
import ChevronLeft from "@src/appV2/lib/assets/icons/chevron_left.svg?react";
import ChevronRight from "@src/appV2/lib/assets/icons/chevron_right.svg?react";
import ChevronUp from "@src/appV2/lib/assets/icons/chevron_up.svg?react";
import Clipboard from "@src/appV2/lib/assets/icons/clipboard.svg?react";
import Clock from "@src/appV2/lib/assets/icons/clock.svg?react";
import ClockHistory from "@src/appV2/lib/assets/icons/clock_history.svg?react";
import Close from "@src/appV2/lib/assets/icons/close.svg?react";
import Coin from "@src/appV2/lib/assets/icons/coin.svg?react";
import Compass from "@src/appV2/lib/assets/icons/compass.svg?react";
import Copy from "@src/appV2/lib/assets/icons/copy.svg?react";
import DateClock from "@src/appV2/lib/assets/icons/date_clock.svg?react";
import Document from "@src/appV2/lib/assets/icons/document.svg?react";
import DressCode from "@src/appV2/lib/assets/icons/dress_code.svg?react";
import Exit from "@src/appV2/lib/assets/icons/exit.svg?react";
import ExtraPay from "@src/appV2/lib/assets/icons/extra_pay.svg?react";
import Eye from "@src/appV2/lib/assets/icons/eye.svg?react";
import House from "@src/appV2/lib/assets/icons/house.svg?react";
import Info from "@src/appV2/lib/assets/icons/info.svg?react";
import Invite from "@src/appV2/lib/assets/icons/invite.svg?react";
import LikeFilled from "@src/appV2/lib/assets/icons/like_filled.svg?react";
import LikeOutlined from "@src/appV2/lib/assets/icons/like_outlined.svg?react";
import MapPin from "@src/appV2/lib/assets/icons/map_pin.svg?react";
import Minus from "@src/appV2/lib/assets/icons/minus.svg?react";
import MoonFilled from "@src/appV2/lib/assets/icons/moon_filled.svg?react";
import MoonOutlined from "@src/appV2/lib/assets/icons/moon_outlined.svg?react";
import NavigationArrow from "@src/appV2/lib/assets/icons/navigation_arrow.svg?react";
import New from "@src/appV2/lib/assets/icons/new.svg?react";
import Passkeys from "@src/appV2/lib/assets/icons/passkeys.svg?react";
import Patients from "@src/appV2/lib/assets/icons/patients.svg?react";
import Phone from "@src/appV2/lib/assets/icons/phone.svg?react";
import Plane from "@src/appV2/lib/assets/icons/plane.svg?react";
import Plus from "@src/appV2/lib/assets/icons/plus.svg?react";
import Priority from "@src/appV2/lib/assets/icons/priority.svg?react";
import QrCode from "@src/appV2/lib/assets/icons/qr_code.svg?react";
import Refund from "@src/appV2/lib/assets/icons/refund.svg?react";
import Remove from "@src/appV2/lib/assets/icons/remove.svg?react";
import Research from "@src/appV2/lib/assets/icons/research.svg?react";
import Search from "@src/appV2/lib/assets/icons/search.svg?react";
import Share from "@src/appV2/lib/assets/icons/share.svg?react";
import Sign24h from "@src/appV2/lib/assets/icons/sign_24h.svg?react";
import SliderSettings from "@src/appV2/lib/assets/icons/slider_settings.svg?react";
import Software from "@src/appV2/lib/assets/icons/software.svg?react";
import Star from "@src/appV2/lib/assets/icons/star.svg?react";
import StarFilled from "@src/appV2/lib/assets/icons/star_filled.svg?react";
import StopWatch from "@src/appV2/lib/assets/icons/stop_watch.svg?react";
import Suitcase from "@src/appV2/lib/assets/icons/suitcase.svg?react";
import SunFilled from "@src/appV2/lib/assets/icons/sun_filled.svg?react";
import SunOutlined from "@src/appV2/lib/assets/icons/sun_outlined.svg?react";
import SunsetFilled from "@src/appV2/lib/assets/icons/sunset_filled.svg?react";
import SunsetOutlined from "@src/appV2/lib/assets/icons/sunset_outlined.svg?react";
import Supplies from "@src/appV2/lib/assets/icons/supplies.svg?react";
import TextBubble from "@src/appV2/lib/assets/icons/text_bubble.svg?react";
import TimeFlies from "@src/appV2/lib/assets/icons/time_flies.svg?react";
import User from "@src/appV2/lib/assets/icons/user.svg?react";
import UserAdd from "@src/appV2/lib/assets/icons/user_add.svg?react";
import UserMini from "@src/appV2/lib/assets/icons/user_mini.svg?react";
import UserStar from "@src/appV2/lib/assets/icons/user_star.svg?react";
import VideoOutlined from "@src/appV2/lib/assets/icons/video_outlined.svg?react";
import type { SVGProps } from "react";

/**
 * @deprecated Use the Icon component instead (src/appV2/redesign/components/Icon.tsx)
 */
export type IconSize = "xSmall" | "small" | "medium" | "large" | "xLarge";

export const ICON_SIZE_EXTRA_SMALL = "0.875rem";
export const ICON_SIZE_SMALL = "1rem";
export const ICON_SIZE_MEDIUM = "1.5rem";
export const ICON_SIZE_LARGE = "2rem";
export const ICON_SIZE_EXTRA_LARGE = "3.5rem";

const sizeMap = {
  xSmall: ICON_SIZE_EXTRA_SMALL,
  small: ICON_SIZE_SMALL,
  medium: ICON_SIZE_MEDIUM,
  large: ICON_SIZE_LARGE,
  xLarge: ICON_SIZE_EXTRA_LARGE,
} as const;

/**
 * @deprecated Use the Icon component instead (src/appV2/redesign/components/Icon.tsx)
 */
export const ICON_TYPES = [
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "block-shift",
  "bolt-filled",
  "bookmark-filled",
  "bookmark-outlined",
  "break",
  "building",
  "calendar-clock",
  "calendar-navigation",
  "calendar-remove",
  "car",
  "chat",
  "checkmark",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clipboard",
  "clock-history",
  "clock",
  "close",
  "coin",
  "compass",
  "copy",
  "date-clock",
  "document",
  "dress-code",
  "exit",
  "extra-pay",
  "eye",
  "house",
  "info",
  "invite",
  "like-filled",
  "like-outlined",
  "map-pin",
  "minus",
  "moon-filled",
  "moon-outlined",
  "navigation-arrow",
  "new",
  "passkeys",
  "patients",
  "phone",
  "plane",
  "plus",
  "priority",
  "qr-code",
  "refund",
  "remove",
  "research",
  "search",
  "sign-24h",
  "slider-settings",
  "share",
  "software",
  "star-filled",
  "star",
  "stop-watch",
  "suitcase",
  "sun-filled",
  "sun-outlined",
  "sunset-filled",
  "sunset-outlined",
  "supplies",
  "text-bubble",
  "time-flies",
  "user-add",
  "user-mini",
  "user",
  "user-star",
  "video-outlined",
] as const;

/**
 * @deprecated Use the Icon component instead (src/appV2/redesign/components/Icon.tsx)
 */
export type IconType = (typeof ICON_TYPES)[number];

const iconMap: Record<IconType, React.FunctionComponent<SVGProps<SVGSVGElement>>> = {
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "block-shift": BlockShift,
  "bolt-filled": BoltFilled,
  "bookmark-filled": BookmarkFilled,
  "bookmark-outlined": BookmarkOutlined,
  break: Break,
  building: Building,
  "calendar-clock": CalendarClock,
  "calendar-navigation": CalendarNavigation,
  "calendar-remove": CalendarRemove,
  car: Car,
  chat: Chat,
  checkmark: Checkmark,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  clipboard: Clipboard,
  clock: Clock,
  "clock-history": ClockHistory,
  close: Close,
  coin: Coin,
  compass: Compass,
  copy: Copy,
  "date-clock": DateClock,
  document: Document,
  "dress-code": DressCode,
  exit: Exit,
  "extra-pay": ExtraPay,
  eye: Eye,
  house: House,
  info: Info,
  invite: Invite,
  "like-filled": LikeFilled,
  "like-outlined": LikeOutlined,
  "map-pin": MapPin,
  minus: Minus,
  "moon-filled": MoonFilled,
  "moon-outlined": MoonOutlined,
  "navigation-arrow": NavigationArrow,
  new: New,
  passkeys: Passkeys,
  patients: Patients,
  phone: Phone,
  plane: Plane,
  plus: Plus,
  priority: Priority,
  "qr-code": QrCode,
  refund: Refund,
  remove: Remove,
  research: Research,
  search: Search,
  share: Share,
  "sign-24h": Sign24h,
  "slider-settings": SliderSettings,
  software: Software,
  star: Star,
  "star-filled": StarFilled,
  "stop-watch": StopWatch,
  suitcase: Suitcase,
  "sun-filled": SunFilled,
  "sun-outlined": SunOutlined,
  "sunset-filled": SunsetFilled,
  "sunset-outlined": SunsetOutlined,
  supplies: Supplies,
  "text-bubble": TextBubble,
  "time-flies": TimeFlies,
  "user-add": UserAdd,
  "user-mini": UserMini,
  "user-star": UserStar,
  user: User,
  "video-outlined": VideoOutlined,
} as const;

/**
 * @deprecated Use the Icon component instead (src/appV2/redesign/components/Icon.tsx)
 */
export interface CbhIconProps extends Omit<SvgIconProps, "color"> {
  type: IconType;
  size?: IconSize;
}

/**
 * @deprecated Use the Icon component instead (src/appV2/redesign/components/Icon.tsx)
 */
export function CbhIcon(props: CbhIconProps) {
  const { type, size = "medium", sx, ...restProps } = props;

  const IconComponent = iconMap[type];

  useLogEffect(
    APP_V2_APP_EVENTS.NON_EXISTING_ICON_REQUESTED,
    {
      type,
    },
    {
      enabled: !isDefined(IconComponent),
    }
  );

  if (!isDefined(IconComponent)) {
    return null;
  }

  return (
    <SvgIcon
      {...restProps}
      sx={{
        width: sizeMap[size],
        height: sizeMap[size],
        ...sx,
      }}
    >
      <IconComponent />
    </SvgIcon>
  );
}
/* eslint-enable max-lines */
/* eslint-enable import/max-dependencies */
